export default __webpack_public_path__ + "static/media/wishlist-1.ef7b5769.png";